import { useMutation, useQueryClient } from "@tanstack/react-query";
import GroupsService from "../../services/GroupsService";
import { usePopup } from "../usePopup";
import { AxiosError } from "axios";
import { PermissionsApiErros } from "../../utils/Api/responses/responses";

const groupsService = new GroupsService();

const useDeleteGroup = () => {
    const queryClient = useQueryClient();
    const { addPopup } = usePopup();
    return useMutation(groupsService.deleteGroup, {
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({
                queryKey: ["group-perms", variables],
            });
            queryClient.invalidateQueries({
                queryKey: ["group-users", variables],
            });
            addPopup({
                title: "Grupo deletado com sucesso.",
                type: "success",
                duration: "temporary",
            });
        },
        onError: (error: AxiosError<PermissionsApiErros>) => {
            addPopup({
                title: "Erro ao deletar grupo.",
                description: error.response?.data.error,
                type: "error",
                duration: "temporary",
            });
        },
    });
};
export default useDeleteGroup;
